import { 
  FETCH_SEASONS, 
  FETCH_INTERVALS,
  SELECT_INTERVAL
} from "./types";

const initState = {
  intervals: [],
  seasons: [],
  selectedInterval: {
    loc: 71,
    hand: [],
    mech: []
  },
  selectedSeason: {}
}

export default function IntervalReducer(state=initState, action) {
  switch (action.type) {
    case FETCH_INTERVALS:
      return { ...state,
        intervals: action.payload,
        selectedInterval: { ...state.selectedInterval,
          hand: action.payload.kau.hand,
          mech: action.payload.kau.mech
        }
      }
    case FETCH_SEASONS:
      return { ...state,
        seasons: action.payload
      }
    case SELECT_INTERVAL:
      return { ...state,
        selectedInterval: {
          hand: action.payload.hand,
          mech: action.payload.mech
        }
      } 
    default:
      return state
  }
}




/* END */


// WEBPACK FOOTER //
// ./src/interval/interval_reducer.js